import { render, staticRenderFns } from "./ClientLogoUpload.vue?vue&type=template&id=d64f1c4a&scoped=true"
import script from "./ClientLogoUpload.vue?vue&type=script&lang=js"
export * from "./ClientLogoUpload.vue?vue&type=script&lang=js"
import style0 from "./ClientLogoUpload.vue?vue&type=style&index=0&id=d64f1c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64f1c4a",
  null
  
)

export default component.exports